import { useEffect, useState } from 'react';
import renderHTML from 'react-render-html';

function MessageTemplateDisplay({ templateContent, params, paramValues }) {
  const [processedTemplateContent, setProcessedTemplateContent] = useState(undefined);

  useEffect(() => {
    let paramSplit = params.split(',');
    let paramValuesSplit= paramValues.split(',');
    if (paramSplit.length !== paramValuesSplit.length) {
      setProcessedTemplateContent('Invalid Content!, please check params');
    }
    else {
      paramSplit.forEach((param, i) => {
        templateContent = templateContent.replaceAll(`{{${param}}}`, paramValuesSplit[i])
      });

      setProcessedTemplateContent(templateContent)
    }
  }, [templateContent, params, paramValues])

  return (
    <div>
      <h3> Message Preview </h3>
      <div style={{ border: '2px solid black', minHeight: '70%', minWidth: '40%'}}> { renderHTML(processedTemplateContent || templateContent) } </div>
    </div>
  );
}

export default MessageTemplateDisplay;
